import { useState, useRef, useEffect, useCallback } from "react";

const Slider = ({ sliderText, value, onChange, onBlur }) => {
  const [isDragging, setIsDragging] = useState(false);
  const sliderRef = useRef(null);

  const getValueFromClientX = useCallback((clientX) => {
    if (!sliderRef.current) return value;
    const rect = sliderRef.current.getBoundingClientRect();
    let ratio = (clientX - rect.left) / rect.width;
    ratio = Math.max(0, Math.min(1, ratio));
    return Math.round(-100 + ratio * (200));
  }, [value]);

  const handleInteraction = useCallback((e) => {
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    onChange(getValueFromClientX(clientX));
  }, [getValueFromClientX, onChange]);

  const handleMouseDown = useCallback((e) => {
    setIsDragging(true);
    handleInteraction(e);
  }, [handleInteraction]);

  const handleUp = useCallback(() => {
    if (isDragging) {
      setIsDragging(false);
      if (onBlur) onBlur(value);
    }
  }, [isDragging, onBlur, value]);

  useEffect(() => {
    if (!isDragging) return;

    const handleMove = (e) => {
      handleInteraction(e);
      e.preventDefault();
    };

    document.addEventListener("mousemove", handleMove);
    document.addEventListener("mouseup", handleUp);
    document.addEventListener("touchmove", handleMove, { passive: false });
    document.addEventListener("touchend", handleUp);

    return () => {
      document.removeEventListener("mousemove", handleMove);
      document.removeEventListener("mouseup", handleUp);
      document.removeEventListener("touchmove", handleMove);
      document.removeEventListener("touchend", handleUp);
    };
  }, [isDragging, handleInteraction, handleUp]);

  const percentage = ((value + 100) / (200)) * 100;

  return (
    <div className={`custom-input-range${value !== -100 ? " has-value" : ""}`}>
      <div className="input-range">
        <label>{sliderText}</label>
        <div className="input-range__wrapper-input">
          <div
            ref={sliderRef}
            className="input-range__track"
            onMouseDown={handleMouseDown}
            onTouchStart={handleMouseDown}
          >
            <div
              className="input-range__fill"
              style={{ width: `${percentage}%` }}
            />
            <div
              className="input-range__thumb"
              style={{ left: `${percentage}%` }}
            >
              <div className="input-range__tooltip">
                {value}%
              </div>
            </div>
          </div>
          <div className="value-container">
            <small>-100%</small>
            <small>100%</small>
          </div>
        </div>
      </div>
    </div>
  );
};

const LabVariations = ({
  quantityVariationInitial,
  priceVariationInitial,
  onVariationBlur,
}) => {
  const [quantityVariation, setQuantityVariation] = useState(quantityVariationInitial || 0);
  const [priceVariation, setPriceVariation] = useState(priceVariationInitial || 0);

  const handleBlur = (fieldName) => (finalValue) => {
    onVariationBlur(fieldName, finalValue);
  };

  return (
    <div className="lab-variations">
      <p>Os valores atualizados aqui refletem em todos os indicadores do cenário</p>
      <Slider
        sliderText="Variação geral das quantidades vendidas"
        value={quantityVariation}
        onChange={setQuantityVariation}
        onBlur={handleBlur("VGdQV")}
      />
      <Slider
        sliderText="Variação geral dos preços de venda"
        value={priceVariation}
        onChange={setPriceVariation}
        onBlur={handleBlur("VGdPV")}
      />
    </div>
  );
};

export default LabVariations;
